//tslint:disable:export-name
import { Container } from 'hypo-container';
import { VtoService } from './VtoService';
import { ConfigStore } from './ConfigStore';
import { ServiceBusController } from './ServiceBusController';
import { VtoViewController } from '../internal/controllers/VtoViewController';
import { VtoSkinCareViewController } from '../internal/controllers/VtoSkinCareViewController';
import { getDecorators } from 'elc-service';
import { QuizApiSdk } from '../api/QuizApiSdk';
import { QuizApiRepository } from '../internal/repositories/QuizApiRepository';
import { root } from 'elc-universal-utils';

export const diContainer = new Container();
export const serviceNames = {
    vtoService: 'VTO_SERVICE',
    configStore: 'CONFIG_STORE',
    serviceBusController: 'SERVICE_BUS_CONTROLLER',
    vtoViewController: 'VTO_VIEW_CONTROLLER',
    vtoSkinCareViewController: 'VTO_SKIN_CARE_CONTROLLER',
    httpTransport: 'HTTP_TRANSPORT',
    quizApiSdk: 'QUIZ_API_SDK',
    quizApiRepository: 'QUIZ_API_REPOSITORY'
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const setConfig = (configJSON: any) => {
    diContainer.config = configJSON;
};

diContainer
    .register(
        serviceNames.configStore,
        diContainer.factory(c => new ConfigStore(c.config))
    )
    .register(serviceNames.vtoService, c => {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return new VtoService((config: any) => {
            setConfig(config);

            return c.get(serviceNames.serviceBusController);
        });
    })
    .register(serviceNames.serviceBusController, () => new ServiceBusController())
    .register(serviceNames.vtoViewController, c => new VtoViewController())
    .register(serviceNames.vtoSkinCareViewController, c => new VtoSkinCareViewController())
    .register(serviceNames.httpTransport, c => {
        return root.HttpTransport;
    })
    .register(serviceNames.quizApiSdk, c => {
        return new QuizApiSdk({ httpTransport: c.get(serviceNames.httpTransport) });
    })
    .register(serviceNames.quizApiRepository, c => {
        return new QuizApiRepository();
    });

const { lazyInject } = getDecorators(diContainer);

export { lazyInject };
